import axios from "axios";
import { CLOUDINARY_URL } from "config";

const instance = axios.create();

export const uploadFile = async (data, config) => {
  return instance.post(CLOUDINARY_URL, data, config);
};
